import {
  // ChevronUp,
  Trash2,
  Edit,
  Eye,
  // PlusCircle,
  // RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";

import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";

const StaffListing = () => {
  const user_data = useSelector((state) => state.user_data);
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         className: "btn btn-success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //     } else {
  //       MySwal.close();
  //     }
  //   });
  // };

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };
  

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "userMaster",
    };
    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/deletebymoduleid",
      payload: reqobj,
    });
  
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setdelete(!deletes);
      fetchServiceData();
      MySwal.fire({
        title: "Deleted!",
        text: "Your staff has been deleted.",
        icon: "success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else {
      console.log(response, "data");
    }
  };

   const formatDBPhoneNumber = (number) => {
  if (!number) return "";

  let cleaned = number.replace(/\D/g, ""); // remove non-digits
  if (cleaned.startsWith("61")) {
    cleaned = "+" + cleaned;
  } else if (cleaned.startsWith("0")) {
    cleaned = "+61" + cleaned.substring(1);
  } else if (!cleaned.startsWith("+61")) {
    cleaned = "+61" + cleaned;
  }

  const noPlus = cleaned.replace("+", "");

  return (
    "+" +
    noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3")
  );
};
  
  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "business Unique Name",
      accessorKey: "businessUniqueName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "FullName",
      accessorKey: "fullName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Email",
      accessorKey: "email",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: " PhoneNumber",
      accessorKey: "phoneNumber",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ cell }) => formatDBPhoneNumber(cell.getValue())
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`${route.AddStaff}/${row.original.id}`);
            }}
          >
            <Edit  className='custome-icon-size' />
          </button>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            //  color="primary"
             onClick={() => {
               navigate(`/teamlistview/${row.original.id}`);
               // navigate(`${route.BusinessOnboarding}/${row.original.ID}`);
             }}
           >
            <Eye  className='custome-icon-size' />     
          </button>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              showConfirmationAlert(row.original.id)
              // handleDelete(row.original.id);
            }}
          >
            <Trash2  className='custome-icon-size' />
          </button>
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const fetchServiceData = async () => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Superadmin/TeamListbybusinessId?businessId=${user_data?.businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }
      setProductlist(serviceData?.ResponseData);
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    fetchServiceData();
  }, []);

  const exportData = productlist.map((item) => ({
    // ID: item?.ID,
    fullName: item?.fullName,
    email: item?.email,
    Address: `${item?.add1}, ${item?.add2}, ${item?.city}, ${item?.state},${item?.country},${item?.zipcode}`,
  }));

  console.log(productlist, "productlist");
  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={fetchServiceData}
          exportData={exportData}
          addMasterPageLink={route.AddStaff}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default StaffListing;
